<template>
  <div class="file-uploader">
    <input
      ref="fileInput"
      type="file"
      name="file"
      multiple
      :accept="accept"
      @change="onHandleFiles"
    />
  </div>
</template>

<script>
import { SDKUtils } from '@/imsdk/index';

const MAX_NUM = 5;

export default {
  props: {
    accept: {
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
    // 对外暴露的click接口，用来触发上传过程
    // 后续如果要处理类似 权限弹框 功能可以在此处实现
    click() {
      this.$refs.fileInput.click();
    },

    onHandleFiles(event) {
      const { files } = event.target;
      if (files.length > MAX_NUM) {
        this.$emit('upload', {
          code: -1,
          id: '',
          message: `一次最多支持选择${MAX_NUM}个文件`,
        });
        return;
      }
      Array.from(files).forEach(async (file) => {
        this.uploadFile(file);
      });

      // eslint-disable-next-line no-param-reassign
      event.target.value = '';
    },

    async uploadFile(file, reSendInfo = null) {
      console.log('[uploadFile]', file, reSendInfo);
      const rs = await SDKUtils.uploadFile(file, reSendInfo, {
        onPreview: (info) => {
          this.$emit('preview', info);
        },
        // 上传进度
        onProgress: (info, progress, controller) => {
          this.$emit('progress', info, progress, controller);
        },
        // 和webIM保持一致，改为100M的上传文件
        maxSize: 100 * 1024 * 1024,
        acceptType: [
          'audio',
          'video',
          'image', // picture
          'text/plain', // .txt
          'text/html',
          'application/pdf', // pdf
          'application/msword', // .doc
          'application/x-zip-compressed', // zip
          'application/zip', // zip
          'application/x-tar', // tar
          'rar', 'application/x-rar', // rar
          '7z', 'application/x-7z-compressed', // 7z
          'xls', 'application/vnd.ms-excel', // excel
          'apk', 'application/vnd.android.package-archive', // apk
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // excel
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
          'application/vnd.openxmlformats-officedocument.presentationml.presentation', // ppt
          'application/vnd.ms-powerpoint', // ppt
          // Start: 特殊类型文件
          'cpt',
          'frm',
          'fvs',
          // End：特殊类型文件
        ],
      });
      this.$emit('upload', rs);
    },
  },
};
</script>

<style lang="less" scoped>
.file-uploader input {
  position: absolute;
  visibility: hidden;
  z-index: -999;
  width: 0px;
  height: 0px;
  top: 0px;
  left: 0px;
}
</style>
